function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.18423 13.7936C10.8672 13.7936 13.8528 10.808 13.8528 7.12503C13.8528 3.44206 10.8672 0.456421 7.18423 0.456421C3.50126 0.456421 0.515625 3.44206 0.515625 7.12503C0.515625 10.808 3.50126 13.7936 7.18423 13.7936ZM5.11643 5.0571C5.35318 4.82035 5.73703 4.82035 5.97378 5.0571L7.29229 6.37561L8.61065 5.05724C8.8474 4.82049 9.23125 4.82049 9.468 5.05724C9.70475 5.294 9.70475 5.67784 9.468 5.91459L8.14964 7.23295L9.46809 8.5514C9.70484 8.78815 9.70484 9.172 9.46809 9.40875C9.23134 9.6455 8.84749 9.6455 8.61074 9.40875L7.29229 8.0903L5.97369 9.4089C5.73694 9.64565 5.3531 9.64565 5.11634 9.4089C4.87959 9.17215 4.87959 8.7883 5.11634 8.55155L6.43494 7.23295L5.11643 5.91445C4.87968 5.6777 4.87968 5.29385 5.11643 5.0571Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/CloseIcon.9dcd7781.svg";
export { SvgComponent as ReactComponent };